// Restaurant hours: 12 PM (noon) to 11 PM
const RESTAURANT_HOURS = Array.from({ length: 12 }, (_, i) => {
  const h = i + 12;
  const label = h === 12 ? "12 PM" : `${h - 12} PM`;
  return { value: String(h).padStart(2, "0"), label };
});

// Full 24-hour range for flights, trains, and everything else
const ALL_HOURS = Array.from({ length: 24 }, (_, i) => {
  const label = i === 0 ? "12 AM" : i < 12 ? `${i} AM` : i === 12 ? "12 PM" : `${i - 12} PM`;
  return { value: String(i).padStart(2, "0"), label };
});

// Every minute for flights and trains
const MINUTES_ALL = Array.from({ length: 60 }, (_, i) => ({
  value: String(i).padStart(2, "0"),
  label: `:${String(i).padStart(2, "0")}`,
}));

// 15-minute intervals for restaurants and general use
const MINUTES_15 = [
  { value: "00", label: ":00" },
  { value: "15", label: ":15" },
  { value: "30", label: ":30" },
  { value: "45", label: ":45" },
];

// value is in "HH:MM" 24-hour format
export default function TimeSelector({ value, onChange, segmentType }) {
  const parts = value ? value.split(":") : ["", ""];
  const hour = parts[0] || "";
  const minute = parts[1] || "00";

  const isRestaurant = segmentType === "restaurant";
  const isPrecise = segmentType === "flight" || segmentType === "train";

  const hours = isRestaurant ? RESTAURANT_HOURS : ALL_HOURS;
  const minutes = isPrecise ? MINUTES_ALL : MINUTES_15;

  const handleHour = (h) => {
    // Snap to nearest valid minute for the new type
    const validMinute = minutes.some(m => m.value === minute) ? minute : "00";
    onChange(h ? `${h}:${validMinute}` : "");
  };

  const handleMinute = (m) => {
    onChange(hour ? `${hour}:${m}` : "");
  };

  return (
    <div style={{ display: "flex", gap: 6 }}>
      <select
        className="form-input"
        value={hour}
        onChange={(e) => handleHour(e.target.value)}
        style={{ flex: 2 }}
      >
        <option value="">Hour</option>
        {hours.map((h) => (
          <option key={h.value} value={h.value}>{h.label}</option>
        ))}
      </select>
      <select
        className="form-input"
        value={minute}
        onChange={(e) => handleMinute(e.target.value)}
        style={{ flex: 1 }}
        disabled={!hour}
      >
        {minutes.map((m) => (
          <option key={m.value} value={m.value}>{m.label}</option>
        ))}
      </select>
    </div>
  );
}
